import {
  QUERY_GET_CONTRACT,
  QUERY_GET_CONTRACT_BY_CASE_ID,
  QUERY_GET_COMMENTS_CASE_BY_ID,
  QUERY_PUT_UPDATECASE,
  QUERY_PUT_UPDATE_CONTRACT_DATA,
  QUERY_POST_CREATECASE,
  QUERY_GET_NEWCASE,
  QUERY_GET_CUSTOMER_CONTRACT_DATA,
  QUERY_POST_LOGIN,
  QUERY_PUT_ASSOCIATE_CONTRACT,
  QUERY_GET_CONTRACT_SIMPLE,
  QUERY_PUT_ATTACH_IDT_PROCESS_TO_CASE,
  QUERY_GET_CONTRACT_LIST,
  QUERY_PUT_UPDATE_CONTRACT,
  QUERY_POST_SIMPLECONTRACT,
  QUERY_POST_CHANGECUSTOMERVEHICLE,
  QUERY_PUT_UPDATE_CONTRACT_SIMPLE,
  QUERY_POST_CONTRACT_ADDVEHICLE,
  QUERY_POST_CONTRACT_CREATEVEHICLE,
  QUERY_POST_CONTRACT_UPDATEVEHICLE,
} from "../../fetch/constantQueries";
import { baseThunk, getUrl } from "../../fetch/basicThunk";
import { fetchGet } from "../../fetch/fetchConfig";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { openModal } from "../modal/modalSlice";
import { errorHandler } from "../../commonFunctions/errorHandler";

export const getContract = baseThunk(
  "contract/GetContract",
  QUERY_GET_CONTRACT,
  "GET",
);

export const getContractSimpleSearch = createAsyncThunk(
  "contract/GetContract",
  async (params, thunkApi) => {
    try {
      const response = await fetch(
        getUrl() + QUERY_GET_CONTRACT +  params.query,
        fetchGet(),
      );

      if (!response.ok) {
        let message = await JSON.parse(await response.text());
        const error = { code: response.status, message: message };
        throw error;
      }

      const data = response.json();
      return data;
    } catch (error) {
      //thunkApi.dispatch(openModal(errorHandler(error)));
      throw error;
    }
  },
);

export const getContractSimple = baseThunk(
  "contract/GetContractSimple",
  QUERY_GET_CONTRACT_SIMPLE,
  "GET",
);

export const associateContract = baseThunk(
  "contract/associateContract",
  QUERY_PUT_ASSOCIATE_CONTRACT,
  "PUT",
);

export const getContractByCaseId = baseThunk(
  "contract/GetContractByCaseId",
  QUERY_GET_CONTRACT_BY_CASE_ID,
  "GET",
);

export const updateCase = baseThunk(
  "case/updateCase",
  QUERY_PUT_UPDATECASE,
  "PUT",
);

export const createCase = baseThunk(
  "case/create",
  QUERY_POST_CREATECASE,
  "POST",
);

export const createSimpleContract = baseThunk(
  "case/createSimpleContract",
  QUERY_POST_SIMPLECONTRACT,
  "POST",
);

export const createContractVehicle = baseThunk(
  "case/createContractVehicle",
  QUERY_POST_CONTRACT_CREATEVEHICLE,
  "POST",
);

export const updateContractVehicle = baseThunk(
  "case/updateContractVehicle",
  QUERY_POST_CONTRACT_UPDATEVEHICLE,
  "PUT",
);



export const changeCustomerVehicle = baseThunk(
  "case/changeCustomerVehicle",
  QUERY_POST_CHANGECUSTOMERVEHICLE,
  "POST",
);

export const getCommentByCaseId = baseThunk(
  "cases/GetCommentsByCaseId",
  QUERY_GET_COMMENTS_CASE_BY_ID,
  "GET",
);

export const newCase = baseThunk("case/newCase", QUERY_GET_NEWCASE, "GET");

export const updateContractData = baseThunk(
  "contract/updateContractData",
  QUERY_PUT_UPDATE_CONTRACT_DATA,
  "PUT",
);

export const getCustomerContractData = baseThunk(
  "contract/GetCustomerContractData",
  QUERY_GET_CUSTOMER_CONTRACT_DATA,
  "GET",
);

export const attachIdtProcessToCase = baseThunk(
  "contract/attachIdtProcessToCase",
  QUERY_PUT_ATTACH_IDT_PROCESS_TO_CASE,
  "PUT",
);

export const getContractList = baseThunk(
  "contract/getContractList",
  QUERY_GET_CONTRACT_LIST,
  "GET",
);

export const updateContract = baseThunk(
  "contract/updateContract",
  QUERY_PUT_UPDATE_CONTRACT,
  "PUT",
);

export const updateContractSimple = baseThunk(
  "contract/updateContractSimple",
  QUERY_PUT_UPDATE_CONTRACT_SIMPLE,
  "PUT",
);
